import { tracked } from '@glimmer/tracking';

import FilterSortBoardFromAnotherSpaceAtSelectPopup from 'webapp/models-custom/filter-sort/board-from-another-space-at-select-popup';

export default class FilterSortBoardFromAnotherSpaceAtSelectPopupInGrid extends FilterSortBoardFromAnotherSpaceAtSelectPopup {
	@tracked override viewId = 'grid';
	override itemDomSelector = 'li.filter-sort-item';
}
